/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
import React from 'react';
import { extend } from 'umi-request';
import { notification } from 'antd';


/**
 * 异常处理程序
 */
const errorHandler = (error: any): Response => {
  const { response, data } = error;
  if (response && response.status) {
    const { status, url } = response;
    const cleanUrl = url ? url.split('?')[0] : '';
    const path = cleanUrl.replace(/^https?:\/\/[^\/]+/, '');
    const isCurrentUserProbe = status === 401 && path === '/api/currentUser';
    if (isCurrentUserProbe) {
      return response;
    }

    // umi-request attaches the parsed response body as error.data
    const body = data;
    const rawMessage =
      body?.message ||
      body?.body?.message ||
      body?.data?.message ||
      body?.errorString ||
      body?.body?.errorString ||
      body?.data?.errorString ||
      body?.error ||
      body?.body?.error ||
      body?.data?.error ||
      body?.msg ||
      body?.body?.msg ||
      body?.data?.msg ||
      body?.detail ||
      body?.body?.detail ||
      body?.data?.detail ||
      null;

    const backendMessage = typeof rawMessage === 'string' ? rawMessage : rawMessage ? JSON.stringify(rawMessage) : null;

    if (backendMessage) {
      notification.error({
        message: React.createElement(
          'div',
          { style: { fontSize: '12px', color: '#3d3c3cff', fontWeight: 'normal', wordBreak: 'break-all', lineHeight: '1.4', paddingRight: '12px' } },
          `Error ${status}: ${path}`
        ),
        description: React.createElement(
          'div',
          { style: { fontSize: '14px', fontWeight: 600, lineHeight: '1.4', paddingRight: '12px', marginTop: '4px' } },
          backendMessage
        ),
        style: { width: 420 },
      });
    } else {
      notification.error({
        message: React.createElement(
          'div',
          { style: { fontSize: '13px', fontWeight: 'normal', wordBreak: 'break-all', lineHeight: '1.4', paddingRight: '12px' } },
          `Error ${status}: ${path}`
        ),
        style: { width: 420 },
      });
    }

  } else if (!response) {
    notification.error({
      message: 'Network Error',
      description: 'Unable to connect to the server.',
    });
  }
  return response;
};

/**
 * 配置request请求时的默认参数
 */
const request = extend({
  errorHandler, // 默认错误处理
  credentials: 'include', // 默认请求是否带上cookie
});

export default request;
